const ERROR_MESSAGES = {
  DEFAULT: "Registration failed. Please try again.",
  VALIDATION: "Please check your input and try again.",
  EMAIL_EXISTS: "An account with this email address already exists.",
  USERNAME_EXISTS:
    "This username is already taken. Please choose a different one.",
  ACCOUNT_EXISTS: "An account with this email or username already exists.",
  INVALID_DATA: "Please check your information and try again.",
  RATE_LIMITED: "Please wait a moment before trying again.",
  CONNECTION_ERROR:
    "Unable to connect to the server. Please check your internet connection and try again.",
};

const ERROR_HEADERS = {
  DEFAULT: "Registration Error",
  VALIDATION: "Validation Error",
  ACCOUNT_EXISTS: "Account Already Exists",
  INVALID_DATA: "Invalid Data",
  RATE_LIMITED: "Too Many Attempts",
  CONNECTION_ERROR: "Connection Error",
};

const STATUS_HANDLERS = {
  400: (data, actions) => {
    if (data.errors) {
      const fieldErrors = data.errors.reduce((acc, err) => {
        acc[err.field] = err.message;
        return acc;
      }, {});
      actions.setErrors(fieldErrors);
    }

    return {
      errorHeader: ERROR_HEADERS.VALIDATION,
      errorMessage: data.message || ERROR_MESSAGES.VALIDATION,
    };
  },

  409: (data) => {
    let errorMessage = ERROR_MESSAGES.ACCOUNT_EXISTS;

    if (data.message?.includes("email")) {
      errorMessage = ERROR_MESSAGES.EMAIL_EXISTS;
    } else if (data.message?.includes("username")) {
      errorMessage = ERROR_MESSAGES.USERNAME_EXISTS;
    }

    return {
      errorHeader: ERROR_HEADERS.ACCOUNT_EXISTS,
      errorMessage,
    };
  },

  422: (data) => ({
    errorHeader: ERROR_HEADERS.INVALID_DATA,
    errorMessage: data.message || ERROR_MESSAGES.INVALID_DATA,
  }),

  429: () => ({
    errorHeader: ERROR_HEADERS.RATE_LIMITED,
    errorMessage: ERROR_MESSAGES.RATE_LIMITED,
  }),
};

const handleResponseError = (status, data, actions) => {
  const handler = STATUS_HANDLERS[status];

  if (handler) {
    return handler(data, actions);
  }

  return {
    errorHeader: ERROR_HEADERS.DEFAULT,
    errorMessage:
      data.message || `Server error (${status}). Please try again later.`,
  };
};

const handleRequestError = () => ({
  errorHeader: ERROR_HEADERS.CONNECTION_ERROR,
  errorMessage: ERROR_MESSAGES.CONNECTION_ERROR,
});

export const handleSignupError = (error, actions) => {
  if (error.response) {
    const { status, data } = error.response;
    return handleResponseError(status, data, actions);
  }

  if (error.request) {
    return handleRequestError();
  }

  return {
    errorHeader: ERROR_HEADERS.DEFAULT,
    errorMessage: ERROR_MESSAGES.DEFAULT,
  };
};
